// extracted by mini-css-extract-plugin
export default {"tasks":"Task_tasks__KBaYv","statusContainer":"Task_statusContainer__I4Lov","tasksContainer":"Task_tasksContainer__MpbE6"};